module.exports = __webpack_public_path__ + "img/gift-01-c1.7e15115e.png";